import { useTimeout } from 'react-use';

const loadGTMScript = (code, eventName) => {
  const gtagScript = `<script defer>    
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${code}');    
    </script>`;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const parsedGtagScript = document
      .createRange()
      .createContextualFragment(gtagScript);
    document.head.appendChild(parsedGtagScript);
    setTimeout(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName);
      }
    }, 1000);
  }
};

export default loadGTMScript;
